const kmMessages = {
  /* 01.General */
"main.name": "ឈ្មោះ",
  "main.sentiment": "អារម្មណ៍",
  "main.urgency": "ភាពបន្ទាន់",
  "main.language": "ភាសា",
  "main.agent": "ភ្នាក់ងារ",
  "main.property_name": "ឈ្មោះអចលនទ្រព្យ",
  "main.booking_number": "លេខកក់",
  "main.check_out": "ចេញពីបន្ទប់",
  "main.check_in": "ចូលបន្ទប់",
  "main.adults": "មនុស្សពេញវ័យ",
  "main.corporate_code": "លេខកូដក្រុមហ៊ុន",
  "main.group_code": "លេខកូដក្រុម",
  "main.promo_code": "លេខកូដផ្សព្វផ្សាយ",
  "main.ai_response": "ការឆ្លើយតប AI",
  "main.template_response": "ការឆ្លើយតបគំរូ",
  "main.converttoticket": "បម្លែងទៅជាសំបុត្រ",
  "main.switch_property": "ប្តូរអចលនទ្រព្យ",
  "main.Group_id": "លេខសម្គាល់ក្រុម",
  "main.integration_id": "លេខសម្គាល់ការរួមបញ្ចូល",
  "main.submit": "ដាក់ស្នើ",
  "main.cancel": "បោះបង់",
    "main.select_template": "ជ្រើសរើសគំរូ",
  "main.rooms": "បន្ទប់",
  "main.rates": "តម្លៃ",

  //footer
    "footer.knowledge": "ចំណេះដឹង",
  "footer.home": "ទំព័រដើម",
  "footer.help": "ជំនួយ",

  //ticket
  "ticket.thank_you": "សូមអរគុណសម្រាប់ការដាក់ស្នើទម្រង់",
  "ticket.ticket": "សំបុត្រ",
  "ticket.details": "សូមបំពេញទម្រង់ដែលពិពណ៌នាអំពីព័ត៌មានលម្អិតនៃសំបុត្រ។",
  "ticket.select_category": "ជ្រើសរើសប្រភេទ",
  "ticket.category": "ប្រភេទ",
  "ticket.title": "ចំណងជើង",
  "ticket.notes": "កំណត់ចំណាំ",
  "ticket.status": "ស្ថានភាព",
  "ticket.assigned_to": "បានចាត់តាំងទៅ",
  "ticket.submit_form": "ដាក់ស្នើទម្រង់",
  
  
  "main.total": "សរុប",
  "main.pastetooutlook": "បិទភ្ជាប់ទៅ Outlook",
  "main.children": "កុមារ",
  "main.promocode": "កូដប្រូម៉ូសិន/ក្រុមហ៊ុន/ក្រុម",
  "main.exact_match_only": "តែការផ្គូផ្គងពិតប្រាកដ",
  "main.search": "ស្វែងរក",
  "main.no_rate_match": "មិនមានតម្លៃណាដែលត្រូវនឹងជម្រើសរបស់អ្នកទេ។ សូមកែប្រែការស្វែងរក ហើយសាកល្បងម្ដងទៀត។",
  "main.translate_to": "បកប្រែទៅ",
  "main.regenerate": "បង្កើតឡើងវិញ",
  "main.copy_text": "ចម្លងអត្ថបទ",
  "main.additional_instructions": "ការណែនាំបន្ថែម",

  "faq.helpcenter": "មជ្ឈមណ្ឌលជំនួយ",
  "faq.reply.email.sabre.question": "តើខ្ញុំអាចឆ្លើយតបអ៊ីមែលដោយប្រើ Aven Hospitality Concierge Email Automation ដោយរបៀបណា?",
  "faq.reply.email.sabre.answer": "បើកអ៊ីមែល ហើយបើកកម្មវិធីបន្ថែម Aven Hospitality។ អ្នកអាចជ្រើសរើសពីជម្រើសបី៖ ប្រើគំរូដែលបានកំណត់ជាមុន បង្កើតការឆ្លើយតបដោយ AI ឬបម្លែងអ៊ីមែលទៅជាសំបុត្រ។",

  "faq.rates.availability.question": "តើខ្ញុំអាចបន្ថែមតម្លៃ ភាពអាចរកបាន និងព័ត៌មានបន្ទប់ទៅការឆ្លើយតបរបស់ខ្ញុំដោយរបៀបណា?",
  "faq.rates.availability.answer": "ប្រើមុខងារ + Rates ដើម្បីបញ្ចូលព័ត៌មានភ្ញៀវដូចជា កាលបរិច្ឆេទ និងចំនួនភ្ញៀវ។ Concierge នឹងបញ្ចូលតម្លៃ និងភាពអាចរកបានត្រឹមត្រូវ។",

  "faq.different.language.question": "តើខ្ញុំគួរធ្វើអ្វី ប្រសិនបើអ៊ីមែលមានភាសាផ្សេង?",
  "faq.different.language.answer": "Aven Hospitality Concierge អនុញ្ញាតឱ្យអ្នកបកប្រែអ៊ីមែលចូលទៅភាសាដែលអ្នកពេញចិត្ត។",

  "faq.pin.addin.question": "តើធ្វើដូចម្តេចដើម្បីធានាថាកម្មវិធីបន្ថែមមាននៅក្នុង Outlook ជានិច្ច?",
  "faq.pin.addin.answer": "ភ្ជាប់កម្មវិធីបន្ថែម Aven Hospitality Concierge នៅក្នុង Outlook ដើម្បីរក្សាឱ្យវាមើលឃើញជានិច្ច។",

  "faq.knowledge.hub.question": "តើជម្រើសស្វែងរក Knowledge Hub គឺជាអ្វី?",
  "faq.knowledge.hub.answer": "ការស្វែងរក Knowledge Hub អនុញ្ញាតឱ្យអ្នកស្វែងរកព័ត៌មានអំពីអចលនទ្រព្យបានយ៉ាងរហ័ស។",

  "faq.reply.email.myma.question": "តើខ្ញុំអាចឆ្លើយតបអ៊ីមែលដោយប្រើ Myma ដោយរបៀបណា?",
  "faq.reply.email.myma.answer": "បើកអ៊ីមែល និងបើកកម្មវិធីបន្ថែម Myma។ អ្នកអាចប្រើគំរូ បង្កើត AI ឬបម្លែងទៅជាសំបុត្រ។",

  "faq.room.details.question": "តើខ្ញុំអាចបន្ថែមព័ត៌មានបន្ទប់ទៅការឆ្លើយតបដោយរបៀបណា?",
  "faq.room.details.answer": "ប្រើ + Rooms ដើម្បីបន្ថែមការពិពណ៌នាបន្ទប់ និងរូបភាព។",

  "faq.myma.different.language.question": "តើខ្ញុំគួរធ្វើអ្វី ប្រសិនបើអ៊ីមែលមានភាសាផ្សេង?",
  "faq.myma.different.language.answer": "Myma អនុញ្ញាតឱ្យអ្នកបកប្រែអ៊ីមែលចូលទៅភាសាដែលអ្នកពេញចិត្ត។",

  "faq.myma.pin.addin.question": "តើធ្វើដូចម្តេចដើម្បីធានាថាកម្មវិធីបន្ថែមមាននៅក្នុង Outlook ជានិច្ច?",
  "faq.myma.pin.addin.answer": "ភ្ជាប់កម្មវិធីបន្ថែម Myma នៅក្នុង Outlook ដើម្បីបើកដោយស្វ័យប្រវត្តិជាមួយអ៊ីមែលនីមួយៗ។",

};

export default kmMessages;
